<!-- 游戏 -->
<template>
  <div class="game">
    <img src="https://cdn.welove520.com/static/res/vue/playbay/game_new.png">
    <div class="introduce">
      <p class="title">游戏介绍</p>
      <p class="content">《我们的小世界农场》是北京发现角科技有限公司专为两人设计的双人互动小游戏。在这里，两个人不仅可以经营自己的农场，还可以和其他农场主交易，互帮互助。</p>
      <p class="title title2">农场主必读</p>
      <p class="content">· 每天进入农场签到，可累计连续签到成就</p>
      <p class="content">· 多多拜访其他人的农场，有可能发现意外惊喜哦</p>
      <p class="content">· 收获多余的农产品可以在商店里卖掉</p>
      <p class="content">· 商店里也可以买到缺少的产品和资源哦</p>
      <a href="https://welove-1253362462.cos.ap-beijing.myqcloud.com/static/test/app-release-for12au28dit.apk">
        <img class="downbtn" src="https://cdn.welove520.com/static/res/vue/playbay/download.png" alt="">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Game",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "game");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game {
  width: 1000px;
  height: 220px;
  margin: 150px auto 100px auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.game > img {
  width: 550px;
}

.introduce {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin-left: 90px;
}

.title {
  font-size: 24px;
  color: #e1556d;
  text-align: center;
}

.title2 {
  margin-top: 30px;
}

.content {
  font-size: 16px;
  color: #303032;
  text-align: justify;
  line-height: 34px;
}

.downbtn{
  width: 180px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Game.vue